export const parseCampaignAssignments = (searchString) => {
  const params = new URLSearchParams(searchString);
  const values = params.getAll('campaign_assignments');

  if (values.length === 0) {
    return [];
  }

  if (values.length === 1 && values[0].includes(',')) {
    return values[0].split(',').filter(Boolean);
  }

  return values.filter(Boolean);
};

export const serializeCampaignAssignments = (campaignIds) => {
  if (!campaignIds || !Array.isArray(campaignIds) || campaignIds.length === 0) {
    return null;
  }
  return campaignIds.map(String).join(',');
};

export const addCampaignToParam = (currentValue, newId) => {
  const current = currentValue ? currentValue.split(',').filter(Boolean) : [];
  const newIdStr = String(newId);
  if (!current.includes(newIdStr)) {
    current.push(newIdStr);
  }
  return current.join(',');
};

export const removeCampaignFromParam = (currentValue, idToRemove) => {
  if (!currentValue) return null;
  const updated = currentValue
    .split(',')
    .filter((id) => id !== String(idToRemove))
    .filter(Boolean);
  return updated.length > 0 ? updated.join(',') : null;
};
